module.exports = __webpack_public_path__ + "static/media/yy3.514c9b10.png";